export default __webpack_public_path__ + "static/industry-telecommunications-ef1d3d1a842fe5df8bd5874f21143682.jpg";